class Geolocation {
  constructor() {
    this.COOKIE_NAME_MARKET = 'expected_market';
    this.COOKIE_NAME_CHOICE = 'market_change';
    this.COOKIE_AGE_DAYS = 30;

    this.geolocate();
  }

  setCookie(name, value) {
    var expires = '';
    var date = new Date();
    date.setTime(date.getTime() + this.COOKIE_AGE_DAYS * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=' + (value || '') + expires + ';domain=.sigvaris.com;Path=/; SameSite=Lax';
  }

  getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }

    return '';
  }

  destroyCookie(name) {
    var expires = '';
    var date = new Date();
    date.setTime(date.getTime() - 1000);
    expires = '; expires=' + date.toUTCString();
    document.cookie = name + '=' + expires + ';domain=.sigvaris.com;Path=/; SameSite=Lax';
    document.cookie = name + '=' + expires + ';Path=/; SameSite=Lax';
  }

  getCurrentMarket() {
    var path = window.location.pathname;
    var parts = path.split('/');

    if (parts.length > 1 && /^[a-z]{2}-[a-z]{2}$/i.test(parts[1])) {
      return parts[1].toLowerCase();
    }

    return null;
  }

  redirectToMarket(market) {
    if (!market) {
      return;
    }

    var currentMarket = this.getCurrentMarket();
    var newPathname = window.location.pathname;

    if (currentMarket) {
      newPathname = newPathname.replace('/' + currentMarket, '/' + market);
    } else {
      newPathname = '/' + market + newPathname;
    }

    if (newPathname === window.location.pathname && window.location.search === '' && window.location.hash === '') {
      return;
    }

    window.location.href = newPathname + window.location.search + window.location.hash;
  }

  isManualNavigation() {
    var perfData = performance.getEntriesByType('navigation')[0];
    if (!perfData) {
      return false;
    }

    return (perfData.type === 'navigate' || perfData.type === 'back_forward')
      && (perfData.redirectCount === 0 || perfData.redirectCount === 2);
  }

  geolocate() {
    var currentMarket = this.getCurrentMarket();
    var expectedMarket = this.getCookie(this.COOKIE_NAME_MARKET);
    var overwrite = this.getCookie(this.COOKIE_NAME_CHOICE);

    if (overwrite) {
      this.destroyCookie(this.COOKIE_NAME_CHOICE);
      this.setCookie(this.COOKIE_NAME_MARKET, currentMarket);
      return;
    }

    if (this.isManualNavigation()) {
      this.setCookie(this.COOKIE_NAME_MARKET, currentMarket);
      return;
    }

    if (!expectedMarket && currentMarket) {
      this.setCookie(this.COOKIE_NAME_MARKET, currentMarket);
      return;
    }

    if (expectedMarket && currentMarket && expectedMarket !== currentMarket) {
      this.redirectToMarket(expectedMarket);
      return;
    }

    if (expectedMarket && !currentMarket) {
      this.redirectToMarket(expectedMarket);
      return;
    }
  }
}

const geolocation = new Geolocation();